import React from "react";
import {
  FiChevronRight,
  FiExternalLink,
  FiFileText,
  FiFolder,
} from "react-icons/fi";

import {
  getMenuItemHref,
  getMenuItemType,
  getTypeLabel,
} from "../utils/menuAdminUtils";

export default function PreviewMega({ tree = [], loading = false }) {
  if (loading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="h-16 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-800"
          />
        ))}
      </div>
    );
  }

  if (!tree.length) {
    return (
      <div className="rounded-3xl border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
        Aucun élément de menu à afficher.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tree.map((root) => (
        <PreviewNode key={root.id} node={root} depth={0} />
      ))}
    </div>
  );
}

function PreviewNode({ node, depth = 0 }) {
  const children = Array.isArray(node.children) ? node.children : [];
  const hasChildren = children.length > 0;
  const type = getMenuItemType(node);
  const href = getMenuItemHref(node);

  return (
    <div
      className={`rounded-3xl border bg-white shadow-sm dark:bg-slate-950 ${
        depth === 0
          ? "border-sky-200 dark:border-sky-900/50"
          : "border-slate-200 dark:border-slate-800"
      }`}
    >
      <div className="flex items-start gap-3 px-4 py-3">
        <div
          className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl ${
            type === "folder"
              ? depth === 0
                ? "bg-sky-50 text-sky-700 dark:bg-sky-950/30 dark:text-sky-200"
                : "bg-violet-50 text-violet-700 dark:bg-violet-950/30 dark:text-violet-200"
              : type === "page"
              ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-200"
              : "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200"
          }`}
        >
          {type === "folder" ? (
            <FiFolder />
          ) : type === "page" ? (
            <FiFileText />
          ) : (
            <FiExternalLink />
          )}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <div className="font-bold text-slate-950 dark:text-slate-50">
              {node.label}
            </div>

            <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
              {depth === 0 ? "Onglet" : getTypeLabel(type)}
            </span>
          </div>

          {href ? (
            <div className="mt-1 truncate text-xs text-slate-500 dark:text-slate-400">
              {href}
            </div>
          ) : (
            <div className="mt-1 text-xs text-slate-500 dark:text-slate-400">
              Dossier contenant {children.length} élément
              {children.length > 1 ? "s" : ""}
            </div>
          )}
        </div>

        {hasChildren ? (
          <FiChevronRight className="mt-2 shrink-0 text-slate-400" />
        ) : null}
      </div>

      {hasChildren ? (
        <div className="border-t border-slate-100 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900/40">
          <div className="space-y-2">
            {children.map((child) => (
              <PreviewNode key={child.id} node={child} depth={depth + 1} />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}